import { Helmet } from "react-helmet-async";
import { SummaryListView } from "../../sections/summary/summary-list-view.js";

export default function LoginPage(){
    return (
        <>
            <Helmet>
                <title>Summary</title>
            </Helmet>
            <SummaryListView />
        </>
    )
}